import type { Bytes } from "../types/Units"

import { ResponseHeader } from "./ResponseHeader"

/**
 * Gets Content-Length from response as bytes.
 *
 * Parses Content-Length header to numeric value.
 *
 * @param r - Request, Response, or XMLHttpRequest object
 * @returns Content length in bytes, or 0 if not available
 *
 * @example
 * ```ts
 * import { ResponseContentLength } from "@pdfking/tfunc"
 *
 * const size = ResponseContentLength(response)
 * console.log(`File size: ${size} bytes`)
 * ```
 */
export const ResponseContentLength = (
  r: Request | Response | XMLHttpRequest
): Bytes => {
  // supports both fetch and xhttp

  const h = ResponseHeader(r, "content-length", "0")

  try {
    return parseInt(h) as Bytes
  } catch {
    return 0 as Bytes
  }
}
